var _mask, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgArrowRight = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: 9,
  height: 16,
  fill: "none",
  viewBox: "0 0 9 16"
}, props), _mask || (_mask = /*#__PURE__*/React.createElement("mask", {
  id: "arrow-right_svg__a",
  fill: "#fff"
}, /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  d: "M.176.49a.6.6 0 0 1 .848 0L8.11 7.577a.6.6 0 0 1 0 .848L1.024 15.51a.6.6 0 0 1-.848-.848L6.836 8 .176 1.34a.6.6 0 0 1 0-.85",
  clipRule: "evenodd"
}))), _path || (_path = /*#__PURE__*/React.createElement("path", {
  fill: "#fff",
  fillRule: "evenodd",
  stroke: "#fff",
  strokeLinecap: "round",
  strokeLinejoin: "round",
  strokeWidth: 2.4,
  d: "M.176.49a.6.6 0 0 1 .848 0L8.11 7.577a.6.6 0 0 1 0 .848L1.024 15.51a.6.6 0 0 1-.848-.848L6.836 8 .176 1.34a.6.6 0 0 1 0-.85",
  clipRule: "evenodd",
  mask: "url(#arrow-right_svg__a)"
})));
export { SvgArrowRight as ReactComponent };